import React from "react";
export const DigitLoader = () => (
  <div className="jk-digit-loader">
    <div className="jk-spinner-wrapper">
      <div className="jk-spinner"></div>
    </div>
  </div>
);
